import * as DVEInterfaces from '#/DefaultViewExtensionInterfaces';
import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import Utilities from '@/Utility/Utilities';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class ExpanderBoxViewModel extends ControlViewModel {

    /**
     * Gibt an, ob die Box zugeklappt ist
     */
    public isCollapsed?: KnockoutObservable<boolean>;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout?: string;

    /**
     * Der Titel des Expanders
     */
    public link?: LinkViewModel;

    /**
     * Gibt das Level (in der Hierarchie) des Expanders an
     */
    public level: number;

    labelErgName: string;

    private isSubscribedForVisiblity: boolean;

    private registeredChildrenForVisibility: ControlViewModel[];
    
    constructor(params: DVEInterfaces.IExpanderBoxViewModelConstructorParameter) {
        super(params);
        
        const LinkViewModel = ComponentManager.getViewModel('LinkViewModel') as any;
        const ImageViewModel = ComponentManager.getViewModel('ImageViewModel') as any;
        const LabelViewModel = ComponentManager.getViewModel('LabelViewModel') as any;

        this.isCollapsed = this.observableOrDefault(params.isCollapsed, false);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.level = this.paramOrDefault(params.level, 1);
        this.link = this.paramOrDefault(params.link, new LinkViewModel({
            parentLocator: this.locator,
            locator: this.locator,
            image: new ImageViewModel({
                source: this.defineComputed(() => {
                    if (this.isCollapsed() === true) {
                        return GlobalConfiguration.inlineImages.EXPANDER_EXPAND;
                    } else {
                        return GlobalConfiguration.inlineImages.EXPANDER_COLLAPSE;
                    }
                }),
                parentLocator: this.locator,
                locator: 'image',
                alternativeText: new LabelViewModel({
                    ergName: this.defineComputed(() => {
                        if (this.isCollapsed() === true) {
                            return 'FACTORY_EXPANDER_EXPAND';
                        } else {
                            return 'FACTORY_EXPANDER_COLLAPSE';
                        }
                    })
                })
            }),
            label: new LabelViewModel({
                ergName: this.paramOrDefault(params.labelErgName,''),
                parentLocator: this.locator,
                locator: 'label'
            }),
            onClick: () => {
                this.isCollapsed(!this.isCollapsed());
            },
            tooltip: new LabelViewModel({
                ergName: this.defineComputed(() => {
                    if (this.isCollapsed() === true) {
                        return 'FACTORY_EXPANDER_EXPAND';
                    } else {
                        return 'FACTORY_EXPANDER_COLLAPSE';
                    }
                })
            })
        }));
    }

    public registerChildForVisibility(childViewModel: ControlViewModel): void {
        if (!this.isSubscribedForVisiblity) {
            this.isSubscribedForVisiblity = true;
            this.defineSubscription(this.isCollapsed,
                (isCollapsed) => {
                    childViewModel.isDisplayed(!isCollapsed);
                });
        }

        if (Utilities.isNullOrUndefined(this.registeredChildrenForVisibility))
            this.registeredChildrenForVisibility = [];

        this.registeredChildrenForVisibility.push(childViewModel);

        this.setVisibilityForChildren(!this.isCollapsed());
    }

    private setVisibilityForChildren(isDisplayed: boolean): void {
        if (Utilities.isNullOrUndefined(this.registeredChildrenForVisibility))
            return;

        this.registeredChildrenForVisibility.forEach(c => c.isDisplayed(isDisplayed));
    }
}

ComponentManager.setViewModel('ExpanderBoxViewModel', ExpanderBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');